import * as z from "zod";
import {CustomerManagementResModel} from "./CustomerManagementResModel";

const schema = z.object({
	content: z.array(CustomerManagementResModel.model).default([]),
	currentPage: z.number().default(0),
	pageSize: z.number().default(20),
	totalCount: z.number().default(0),
	totalPages: z.number().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const CustomerManagementSearchResModel = {schema, model};
export type ICustomerManagementSearchResModel = z.infer<typeof CustomerManagementSearchResModel.model>;
export const DEFAULT_CUSTOMER_MANAGEMENT_SEARCH_RES: ICustomerManagementSearchResModel = {
	content: [],
	currentPage: 0,
	pageSize: 20,
	totalCount: 0,
	totalPages: 0
};
